<style lang="scss">
    .orders-modal {
        .no-orders, .loading-wrapper {
            text-align: center;
            padding: 20px 0;
        }
        .order-link {
            color: #0275d8;
        }

        .col-last{
            padding-right: 0px !important;
        }

        .col-first{
            padding-left: 0px !important;
        }
        .header-row{
            font-size: 16px;
            margin-left: 0px !important;
            margin-right: 0px !important;
            border-bottom: 1px solid #A7A7A7;
            height: 40px;
            vertical-align: unset;
            padding-top: 10px;
        }

        .body-row{
            font-size: 16px;
            margin-left: 0px !important;
            margin-right: 0px !important;
            border-bottom: 1px solid #A7A7A7;
            height: 60px;
            vertical-align: unset;
            padding-top: 20px;
        }

        .url-link{
            color : #00D38A;
        }
    }

    @media screen and (max-width: 500px) {
        .orders-modal{
            .header-row{
				font-size: 12px !important;
			}

			.body-row{
				font-size: 12px !important;
			}

            .p-a-lg {
                padding: 2rem !important;
            }


            .url-link{
                font-size: 20px !important;
            }
        }
    }
</style>

<template>
    <div class="orders-modal modal fade" id="ordersModal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div class="row">
                    <div class=" col-sm-12 col-xs-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12">
                                    <h4 class="modal-title" :style="$highlightColor">ORDER HISTORY</h4>
                                    <div class="loading-wrapper" v-if="loading">
                                        <font-awesome-icon icon="spinner-third" spin size="2x"></font-awesome-icon>
                                    </div>
                                    <div v-if="orders && !loading" class="row">
                                        <template v-if="orders.length > 0">
                                           <div class="row header-row">
                                                <div class="col col-md-3 col-sm-4 col-xs-4 col-first">
                                                    Order No
                                                </div>
                                                <div class="col col-md-3 col-sm-4 col-xs-4">
                                                    Date
                                                </div>
                                                <div class="col col-md-3 col-sm-3 col-xs-3">
                                                    Total
                                                </div>
                                                <div class="col col-md-3 col-sm-1 col-xs-1 col-last">

                                                </div>
                                            </div>
                                            <div class="row body-row"  v-for="order in orders">
                                                <div class="col col-md-3 col-sm-4 col-xs-4 col-first">
                                                    {{order.orderNumber}}
                                                </div>
                                                <div class="col col-md-3 col-sm-4 col-xs-4">
                                                    {{date(order.createdAt)}}
                                                </div>
                                                <div class="col col-md-3 col-sm-3 col-xs-3">
                                                    {{order.total | displayPrice}}
                                                </div>
                                                <div class="col col-md-3 col-sm-1 col-xs-1 col-last text-right url-link">
                                                    <a :href="orderUrl + '/' + order.id" target="_blank">
                                                    <font-awesome-icon :icon="['fas','fa-search']"></font-awesome-icon></a>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-else class="row text-ceter no-orders"  >
                                            You do not have any orders with {{user.name}} yet.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

	</div>
</template>

<script>
    import Configure from "../../mixins/configure";

    export default {
        mixins:[Configure],
        created() {
            this.$nextTick(() => {
                let vm = this
                $(this.$el).on("show.bs.modal", function() {
                    if (!vm.orders) {
                        vm.getOrders()
                    }
                })
            })
        },
        data() {
            return {
                orders: null,
                loading: false,
                orderUrl: ab.orderUrl
            }
        },
        computed: {
            loggedInUser() {
                if (!this.$store.state.loggedInUser) {
                    this.orders = null
                }
                return this.$store.state.loggedInUser
            },
            user() {
                return this.$store.state.user
            },
        },
        methods: {
            getOrders() {
                if (this.loggedInUser) {
                    this.loading = true

                    this.$http.get(`${ab.apiUrl}/orders/from/${this.user.id}`, {
                        params: {
                            'api_token': this.loggedInUser.token
                        }
                    }).then((response) => {
                        this.loading = false
                        this.orders = response.data.items

                    }).catch(() => {
                        this.loading = false
                        this.orders = []
                    })
                }
            },
            date(dateString) {
                let d = new Date(dateString)
                return d.toDateString()
            }
        }
    }

</script>
